import { createTheme, lighten, type Shadows } from '@mui/material/styles';

import { amber_amber, amber_dark_grey, amber_faded_black, amber_grey, white } from './color';

export const mui_theme = createTheme({
  // MUI shadows type expects a 25-element tuple; fill with 'none' to disable all elevation shadows
  shadows: Array(25).fill('none') as Shadows,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  typography: {
    fontFamily: ['Source Sans Pro', 'sans-serif'].join(','),
    fontSize: 12,
    h5: {
      fontWeight: 600,
    },
    h4: {
      color: amber_faded_black,
      fontWeight: 400,
      fontSize: 26,
    },
  },
  palette: {
    primary: {
      light: lighten(amber_grey, 0.7),
      main: amber_grey,
      dark: amber_grey,
      contrastText: white,
    },
    secondary: {
      light: lighten(amber_amber, 0.5),
      main: amber_amber,
      dark: amber_amber,
      contrastText: white,
    },
    mode: 'light',
    background: {
      default: white,
      paper: white,
    },
    text: {
      primary: amber_grey,
    },
  },
  components: {
    MuiCardHeader: {
      styleOverrides: {
        root: {
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 14,
          paddingRight: 14,
          alignItems: 'center',
          '@media(min-width:600px)': {
            paddingLeft: 14,
            paddingRight: 14,
          },
        },
        title: {
          textAlign: 'left',
          fontSize: 15,
          color: amber_dark_grey,
        },
        action: {
          marginTop: 0,
          marginRight: 0,
          '@media(min-width:600px)': {
            marginRight: 0,
          },
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 14,
          paddingRight: 14,
          '@media(min-width:600px)': {
            paddingLeft: 14,
            paddingRight: 14,
          },
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          paddingTop: 24,
          paddingBottom: 24,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          cursor: 'pointer',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
  },
});
